import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { Carousel6Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Carousel6Content;
}

const Carousel6TabletHead: FC<Props> = withErrorBoundary(({ className = "", content: { title, description } }) => {
  return (
    <StyledCarousel6TabletHead className={className}>
      <h2 className="Font_48_54_600 lg:Font_40_48_600">{title}</h2>
      <Markdown className="Carousel6TabletHead__description Color_secondary Font_24_32_450">{description}</Markdown>
    </StyledCarousel6TabletHead>
  );
}, {});

const StyledCarousel6TabletHead = styled.div`
  .Carousel6TabletHead__description {
    margin-top: 24px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Carousel6TabletHead__description {
      margin-top: 16px;
    }
  }
`;

export { Carousel6TabletHead };
